import { ClosedResponseOptionRow } from '@/components/presentation/ProjectSurveyResponses';
import type { MatrixSliderItem } from './interfaces';
import styles from './style/MatrixSlider.Data.module.css';

type Props = {
  items: MatrixSliderItem[];
  onClick: (rowId: number) => void;
};

export const MatrixSliderAggregateData = ({
  items,
  onClick,
}: Props) => {

  return (
    <div className={styles.options}>
      {items.map(item => (
        <ClosedResponseOptionRow
          key={item.id}
          onViewAll={() => onClick(item.id)}
          color={item.color}
          subtitle={`(Avg: ${item.displayAvg})`}
          label={item.name} />
      ))}
    </div>
  );

};

export default MatrixSliderAggregateData;